<script>
import Config from '@/config';
import {mapGetters} from 'vuex';
import Main from '@/mixins/main';
import Size from '@/mixins/size';
import {scoreExchange, scoreChange} from '@/api';
import {formatTime, pageIsFinish} from '@/libs/util';
import {Toast, Field, Button, List, PullRefresh} from 'vant';

export default {
  mixins: [
    Main,
    Size
  ],
  components: {
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      page: 1,
      scoreChange: [],

      outSn: '',
      kwh: '',

      loading: false,
      finished: false,
      refreshing: false,
      listLoading: false
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    score() {
      return this.user ? this.user.score : '--';
    },
    outSnError() {
      return Boolean(this.outSn && this.outSn.trim().length < 6);
    },
    kwhSnError() {
      return Boolean(this.kwh && value.this.kwh().length < 3);
    },
    disabled() {
      return !this.outSn || this.outSnError || !this.kwh || this.kwhSnError;
    }
  },
  mounted() {
    window.document.title = '速电通-我的积分';

    this.loadMyInfo();
  },
  methods: {
    refresh() {
      this.page = 1;
      this.finished = false;
      this.loadData();
      this.loadMyInfo();
    },
    loadData() {
      if (this.refreshing) {
        this.scoreChange = [];
        this.refreshing = false;
      }

      this.listLoading = true;
      scoreChange(this.page, Config.pageSize).then(response => {
        if (response.data.code === Config.successCode) {
          response.data.body.data = response.data.body.data.map(value => {
            value.createdAtShow = formatTime(new Date(value.createdAt));
            return value;
          });
          this.scoreChange = this.page === 1 ? response.data.body.data : this.scoreChange.concat(response.data.body.data);
          this.finished = pageIsFinish(response.data.body);
          this.page = response.data.body.page + 1;
        }
      }).finally(() => this.listLoading = false).catch(() => this.finished = true);
    },
    exchange() {
      if (this.disabled) {
        return;
      }

      this.loading = true;
      scoreExchange(this.outSn, this.kwh).then(response => {
        if (response.data.code === Config.successCode) {
          this.refresh();
          Toast.success('兑换成功');
        }
      }).finally(() => this.loading = false);
    },
    toStore() {
      this.$router.push({name: 'goods'});
    }
  }
}
</script>

<template>
  <van-pull-refresh v-model="refreshing" @refresh="refresh" id="score-exchange">
    <div class="info">
      <div class="label">可用积分</div>
      <div class="score-button">
        <div class="score">{{ score }}</div>
        <div class="button" @click="toStore">积分商城</div>
      </div>
    </div>
    <div class="fields">
      <van-field v-model="outSn" :error="outSnError" clearable label="订单号" placeholder="请至少输入第三方充电订单号后六位" titleWidth="60px"/>
      <van-field v-model="kwh" :error="kwhSnError" clearable type="digit" label="充电量" placeholder="请输入第三方充电订单充电电量" titleWidth="60px"/>
    </div>
    <div class="submit-button">
      <van-button :disabled="disabled" :loading="loading" @click="exchange" v-prevent-re-click round block color="#009251" loading-text="兑换中...">兑换积分</van-button>
    </div>
    <div class="exchange-tip">温馨提示：使用速电通平台充电，积分将自动累计</div>
    <div class="score-history">
      <div class="title">积分明细</div>
      <van-list v-model="listLoading" :finished="finished" :finished-text="scoreChange.length === 0 ? '' : '没有更多了'" @load="loadData">
        <div v-for="(item, index) in scoreChange" :key="index" class="item">
          <div class="left">
            <div class="label">{{ item.title }}</div>
            <div class="datetime">{{ item.createdAtShow }}</div>
          </div>
          <div class="change-value" :class="item.type === 1 ? 'add' : 'sub'">{{ item.type === 1 ? '+' : '-' }}{{ item.score }}</div>
        </div>
      </van-list>
      <div v-if="scoreChange.length === 0" :style="{height: (height - 346) + 'px'}" class="no-data">
        <div class="content">
          <img src="../assets/images/no-data.png"/>
        </div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<style scoped>
#score-exchange {
  background-color: #F8F8F8;
}

#score-exchange .info {
  background-color: #009251;
  padding: 12px 24px 12px 12px;
}

#score-exchange .info .label {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

#score-exchange .info .score-button {
  display: flex;
  margin-top: 12px;
  align-items: center;
  justify-content: space-between;
}

#score-exchange .info .score-button .score {
  color: white;
  font-size: 32px;
  font-weight: bold;
}

#score-exchange .info .score-button .button {
  display: flex;
  align-items: center;
  justify-content: center;

  color: #009251;
  font-size: 14px;
  font-weight: bold;
  padding: 6px 12px;
  border-radius: 14px;
  background-color: white;
}

#score-exchange .submit-button {
  background-color: white;
  padding: 12px 24px 8px 24px;
}

#score-exchange .submit-button .van-button {
  box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
}

#score-exchange .exchange-tip {
  color: #999999;
  font-size: 12px;
  text-align: center;
  padding-bottom: 12px;
  background-color: white;
}

#score-exchange .score-history {
  margin-top: 8px;
  background-color: white;
}

#score-exchange .score-history .title {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 24px 12px 12px 12px;
}

#score-exchange .score-history .item {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 0;
  margin: 0 12px;
  border-bottom: 1px solid #EEEEEE;
}

#score-exchange .score-history .item .left {
  display: flex;
  flex-direction: column;
}

#score-exchange .score-history .item .left .label {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

#score-exchange .score-history .item .left .datetime {
  color: #9d9d9d;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

#score-exchange .score-history .item .change-value {
  font-size: 18px;
  font-weight: bold;
}

#score-exchange .score-history .item .change-value.add {
  color: #009251;
}

#score-exchange .score-history .item .change-value.sub {
  color: #FC2313;
}
</style>
